/**
 * Created by Udara Prabath
 * Date: 10/20/2020
 * Using: IntelliJ IDEA
 */

import React, {Component} from 'react';
import './TeachersSlides.scss';
import Slider from "react-slick";
import {Card, CardBody, Row, Col} from "reactstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Button} from "reactstrap";
import * as constants from "../../const/constants";

import i from "react-icofont";
import {lang, language} from "../../const/language";
import {getSliderSetting} from "../../utils/commonFunc";

class App extends Component {

    viewLectureHandler = (object) => {
        this.props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_TEACHER_ROUTE}`,
            state: `${object.id}`
        })
    };

    render() {
        let {teachers} = this.props;

        let settings = getSliderSetting(teachers);

        return(
            <div>
                <div className={"teachers-slide-show"}>
                    <Slider {...settings}>
                        {
                            teachers.map((element, index)=>{
                                return(
                                    <div key={index}>
                                        <div
                                            className={`slideshow-wrapper shadow border-0 card`}>
                                            <div className={"display-inline slideshow-user-wrapper"}>
                                                <img src={element.imageUrl} alt={"."}
                                                     className={"blur-img"}/>
                                                <img src={element.imageUrl} alt={"."}
                                                     className={"slideshow-pro-image shadow"}/>
                                                {/*<h2 className={"view-icon"}><i className="icofont-search-job"/>*/}
                                                {/*</h2>*/}
                                                <div className={"slideshow-middle"}>
                                                    <div className={"cursor minHeight"}>
                                                        <div onClick={() => this.viewLectureHandler(element)}>
                                                            <h4 className={"topic"}>{element.name}</h4>

                                                            <Row className={"card-row"}>
                                                                <Col xs="12"><p className={"qualification"}>{element.qualification} </p></Col>
                                                            </Row>
                                                            <Row className={"card-row"}>
                                                                <Col xs="12"><p className={"description"}>{element.description} </p></Col>
                                                            </Row>
                                                        </div>

                                                        <div className={"btn-ctrl"}>
                                                            <Button className={"reg-btn com-btn bold-text "} onClick={() => this.viewLectureHandler(element)}>
                                                                {language[lang].viewBtnText}
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </Slider>
                </div>
            </div>
        )
    }
}

export default App;